<template>
  <aside class="order-details-wrapper hide-on-lg" :class="{open}">
    <header class="header">
      <span class="title">
        Pedido<br>
        <span class="order">{{ orderId }}</span>
      </span>

      <XIcon @click="closeDetails" size="24" color="#0F172A" />
    </header>

    <main class="main">
      <div class="retailer-info">
        <span>Loja: {{ retailerName }} em {{ purchasedDate | dateFilter }}</span>
        <span>{{ products.length }} itens</span>
      </div>

      <ProductList :products="products" />
    </main>

    <footer class="footer">
      <router-link tag="a" to="/portal" exact>Ver no Parcelex</router-link>
    </footer>
  </aside>
</template>

<script>
import { XIcon } from '@vue-hero-icons/outline';
import StringMixin from '@/mixins/string';
import ProductList from './ProductList.vue';

export default {
  name: 'mobile-order-details',
  props: {
    orderId: {
      type: String,
    },
    purchasedDate: {
      type: String,
    },
    retailerName: {
      type: String,
    },
    products: {
      type: Array,
    },
    open: {
      type: Boolean,
    },
  },
  mixins: [StringMixin],
  components: {
    XIcon,
    ProductList,
  },
  methods: {
    closeDetails() {
      this.$emit('onClose');
    },
  },
};
</script>

<style lang="scss" scoped>
  .order-details-wrapper {
    width: 100%;
    position: absolute;
    z-index: 2;
    height: 100%;
    background-color: white;

    right: -992px;
    transition: right .5s ;

    &.open {
      right: 0;
    }

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      padding: 16px 24px;
      border-bottom: 1px solid var(--gray-200);

      .title {
        @extend .small-regular;
        font-size: 14px;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .order {
        @extend .small-bold;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .main {
      padding: 24px 24px 20px 24px;
    }

    .footer {
      @extend .small-regular;
      font-size: 16px;
      line-height: 24px;
      text-align: center;

      a {
        text-decoration: none;
        -webkit-tap-highlight-color: transparent;
      }
    }
  }

  .retailer-info {
    @extend .small-regular;

    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 14px;
    line-height: 20px;
    color: var(--gray-700);
  }
</style>
